import { Badge } from '@/components/shared/Badge';
import { Panel } from '@/components/shared/Panel';
import { WeaponIcon } from '@/components/shared/WeaponIcon';
import type { SignupHistoryGroup } from '@/types/domain';
import { formatDateTime } from '@/utils/date';

interface SignupTimelineProps {
  groups: SignupHistoryGroup[];
}

export function SignupTimeline({ groups }: SignupTimelineProps): JSX.Element {
  return (
    <div className="signup-timeline">
      {groups.map((group) => (
        <Panel
          key={group.event.id}
          title={group.event.title}
          description={`${formatDateTime(group.event.startsAt)} - ${group.event.status}`}
        >
          <div className="signup-timeline__items">
            {group.signups.map((signup) => (
              <article key={signup.id} className="signup-timeline__item">
                <WeaponIcon imagePath={signup.weaponImagePathSnapshot} label={signup.weaponNameSnapshot} size="md" />
                <div>
                  <strong>{signup.weaponNameSnapshot}</strong>
                  <p>
                    {signup.roleCategorySnapshot}
                    {signup.slotNoteSnapshot ? ` - ${signup.slotNoteSnapshot}` : ''}
                    {' - '}Party {signup.partyNumberSnapshot}
                  </p>
                </div>
                <Badge tone={signup.status === 'joined' ? 'success' : signup.status === 'waitlist' ? 'warning' : 'default'}>
                  {signup.status}
                </Badge>
              </article>
            ))}
          </div>
        </Panel>
      ))}
    </div>
  );
}
